module.exports = __webpack_public_path__ + "static/media/edit_icon.ee60d35d.svg";